import {AppTourService} from '../../services/app-tour/app-tour.service';
import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable, Subject, takeUntil} from 'rxjs';
import {
  CollapseMenuUtilitiesAnimation,
  CollapseNavigationsUtilitiesAnimation,
  HideMenuUtilitiesAnimation
} from '../../animations/collapse-menu-utilities.animation';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {PanelUtilitiesActions, PanelUtilitiesState} from '../../models/panel-utilities';
import {SharedDataService} from '../../services/shared-data/shared-data.service';

@Component({
  selector: 'app-home-page-template',
  templateUrl: './home-page-template.component.html',
  styleUrls: ['./home-page-template.component.scss'],
  animations: [
    CollapseMenuUtilitiesAnimation,
    HideMenuUtilitiesAnimation,
    CollapseNavigationsUtilitiesAnimation,
    fadeInAnimation
  ]
})
export class HomePageTemplateComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  templatePanel$: Observable<TemplateRef<any>> = this.store.select<TemplateRef<any>>(PanelUtilitiesState.getTemplatePanel);
  isCollapsed: boolean;
  changeFloat: boolean;
  forceClosed: boolean;
  tplFormUtilitiesPanel: TemplateRef<any>;
  templateTitle: string;
  hasTemplate = false;
  loadPanelTitle: boolean;
  skeletonTemplate: any[] = [];
  MaxWidthForPanel = 1350;
  private destroy$ = new Subject();
  blockCloseCollapseMenu = false;
  innerWidth = 0;
  intervalResize = null;
  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store,
    private sharedDataService: SharedDataService,
    private appTourService: AppTourService
  ) {
    this.sharedDataService.Data.subscribe(result => {
      if (result) {
        this.tplFormUtilitiesPanel = result.tpl;
        this.templateTitle = result.templateTitle;
        this.hasTemplate = true;
        setTimeout(() => {
          // funcionalidad temporal
          this.loadPanelTitle = true;
        }, 1300);
      } else {
        this.templateTitle = '';
        this.tplFormUtilitiesPanel = null;
        this.hasTemplate = false;
        setTimeout(() => {
          // funcionalidad temporal
          this.loadPanelTitle = true;
        }, 1300);
      }
    });
    this.appTourService.getIsCollapsedMenu.pipe(takeUntil(this.destroy$)).subscribe(async (isCollapsed) => {
      if (isCollapsed === null) {
        return;
      }
      this.blockCloseCollapseMenu = true;
      await this.onClosable(isCollapsed);
      setTimeout(() => {
        this.blockCloseCollapseMenu = false;
      }, 2000);
    });

    // Usado para mostrar u ocultar el panel de utilidades.
    this.store.select(PanelUtilitiesState.getIsVisible).pipe(takeUntil(this.destroy$)).subscribe({
      next: async (isVisible: boolean | null) => {
        if (isVisible === null) return;

        this.isCollapsed = !isVisible;
        this.forceClosed = !isVisible;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.initValues();
    this.cdr.detectChanges();
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
    setTimeout(() => {
      if (window.innerWidth <= this.MaxWidthForPanel) {
        this.isCollapsed = true;
        this.changeFloat = true;
        this.cdr.detectChanges();
        this.innerWidth = window.innerWidth;
      } else {
        this.changeFloat = false;
      }
    });
  }

  initValues(): void {
    this.innerWidth = window.innerWidth;
    this.forceClosed = true;
    this.isCollapsed = false;
    this.skeletonTemplate = [
      {
        multiple: true,
        style: 'width: 100%',
        items: [
          {
            type: 'input',
            style: 'width: calc(100% - 60px); height: 30px;',
            classes: 'mr-xlg'
          },
          {
            type: 'input',
            style: 'width: 30px; height: 30px'
          }
        ]
      }
    ];
  }

  @HostListener('window:resize', ['$event'])
  async onResize(event: any): Promise<void> {

    clearTimeout(this.intervalResize);
    this.intervalResize = setTimeout(() => {
      this.innerWidth = event.target.innerWidth;
      if (event.target.innerWidth <= this.MaxWidthForPanel) {
        this.changeFloat = true;
        if (this.forceClosed) {
          this.isCollapsed = true;
        }
      } else {
        this.changeFloat = false;
        if (!this.forceClosed) {
          this.isCollapsed = false;
        }
      }
    }, 200);
  }

  async onClosable(value): Promise<void> {
    await this.toggleClosed();
    this.isCollapsed = value;
    this.forceClosed = value;
  }

  async toggleClosed(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new PanelUtilitiesActions.ToggleClosed())));
    await firstValueFrom((this.store.dispatch(new PanelUtilitiesActions.SetIsVisible(null))));
  }
}
